import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="btn secondary icon-link"
      onClick={(event) => {
        event.preventDefault();
        navigate(-1);
      }}
    >
      <FontAwesomeIcon className="mr-2" icon={faArrowLeft} />
      <span>
        Tillbaka
        <span className="show-for-sr">
          {/* {" "}
        till steg {currentStepIndex
          ? currentStepIndex
          : 2} av {numSteps} */}
        </span>
      </span>
    </button>
  );
};
export default BackButton;
